import { TextStyle } from 'react-native';
import { MOBILE_TYPOGRAPHY } from '@/constants/shared/theme/typography';

/**
 * Mobile Typography
 * 
 * Shared typography styles matching Figma design for mobile screens.
 * These can be used across all mobile components for consistency.
 * 
 * Font family: Euclid Circular B (system default used as fallback)
 */

// Base colors (can be overridden per screen)
const DEFAULT_COLORS = {
  primary: '#EEF1F4',
  secondary: '#919191',
  muted: 'rgba(238, 241, 244, 0.5)',
  linkBlue: '#6B8EFE',
  linkPink: '#F55560',
};

/** @deprecated use the named MOBILE_TYPOGRAPHY export from @/constants/shared/theme — a
 * distinct scale; useTypography() returns only the primary TYPOGRAPHY scale. */
export { MOBILE_TYPOGRAPHY };

/**
 * Pre-composed text styles with colors for common use cases
 */
export const MOBILE_TEXT_STYLES = {
  // Titles
  titlePrimary: {
    ...MOBILE_TYPOGRAPHY.title,
    color: DEFAULT_COLORS.primary,
  } as TextStyle,

  titleSecondary: {
    ...MOBILE_TYPOGRAPHY.title,
    color: DEFAULT_COLORS.secondary,
  } as TextStyle,

  // Subtitles
  subtitlePrimary: {
    ...MOBILE_TYPOGRAPHY.subtitle,
    color: DEFAULT_COLORS.primary,
  } as TextStyle,

  subtitleSecondary: {
    ...MOBILE_TYPOGRAPHY.subtitle,
    color: DEFAULT_COLORS.secondary,
  } as TextStyle,

  // Body text
  bodyPrimary: {
    ...MOBILE_TYPOGRAPHY.body,
    color: DEFAULT_COLORS.primary,
  } as TextStyle,

  bodySecondary: {
    ...MOBILE_TYPOGRAPHY.body,
    color: DEFAULT_COLORS.secondary,
  } as TextStyle,

  bodyLargePrimary: {
    ...MOBILE_TYPOGRAPHY.bodyLarge,
    color: DEFAULT_COLORS.primary,
  } as TextStyle,

  // Labels (muted color for uppercase labels)
  labelMuted: {
    ...MOBILE_TYPOGRAPHY.label,
    color: DEFAULT_COLORS.muted,
  } as TextStyle,

  labelSecondary: {
    ...MOBILE_TYPOGRAPHY.label,
    color: DEFAULT_COLORS.secondary,
  } as TextStyle,

  // Links
  linkBlue: {
    ...MOBILE_TYPOGRAPHY.link,
    color: DEFAULT_COLORS.linkBlue,
  } as TextStyle,

  linkPink: {
    ...MOBILE_TYPOGRAPHY.link,
    color: DEFAULT_COLORS.linkPink,
  } as TextStyle,

  linkPinkLarge: {
    ...MOBILE_TYPOGRAPHY.bodyLarge,
    color: DEFAULT_COLORS.linkPink,
  } as TextStyle,
} as const;

/**
 * Helper to create text style with custom color
 */
export const createTextStyle = (
  base: keyof typeof MOBILE_TYPOGRAPHY,
  color: string
): TextStyle => ({
  ...MOBILE_TYPOGRAPHY[base],
  color,
});
